import { ref, computed } from 'vue';

const toasts = ref([]);
const idCounter = ref(0);

const toast = {
    add(type, message, duration = 5000) {
        const id = idCounter.value++;
        const toast = { id, type, message, duration };

       // toasts.value.push(toast);
        toasts.value = [toast, ...toasts.value];

        const removeToast = () => {
            const index = toasts.value.findIndex((t) => t.id === id);
            if (index !== -1) {
                toasts.value.splice(index, 1);
            }
        };

        setTimeout(removeToast, duration);
    },

    addInfo(message, duration) {
        toast.add('info', message, duration);
    },

    addError(message, duration) {
        toast.add('error', message, duration);
    },

    addSuccess(message, duration) {
        toast.add('success', message, duration);
    },

    getToasts() {   
        return computed(() => toasts.value);
    }
}

export function useToast() {
    return {
        addInfo: toast.addInfo,
        addError: toast.addError,
        addSuccess: toast.addSuccess,
        addToast: toast.add,
        getToasts: toast.getToasts
    }
}
